var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "448.000000pt",
    height: "385.000000pt",
    viewBox: "0 0 448.000000 385.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,385.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M840 3818 c-50 -18 -90 -55 -421 -387 -418 -417 -414 -412 -414 -551 0 -138 -3 -134 409 -547 316 -317 368 -365 421 -389 255 -117 540 164 423 417 -15 32 -54 87 -93 128 l-68 72 969 -4 c966 -3 969 -3 1053 -25 412 -110 692 -452 718 -878 28 -459 -271 -870 -718 -985 -78 -21 -116 -23 -529 -28 -441 -6 -445 -6 -498 -30 -71 -32 -147 -115 -167 -183 -19 -66 -19 -150 0 -216 20 -68 96 -151 167 -183 52 -24 57 -24 443 -27 423 -4 553 4 713 43 748 181 1265 866 1229 1627 -32 661 -465 1234 -1093 1444 -58 20 -149 45 -202 57 -94 20 -125 21 -1090 24 l-994 4 66 69 c89 94 108 135 114 236 4 73 1 88 -23 143 -34 76 -113 152 -181 175 -66 22 -166 20 -234 -6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/BackIcon.909cef6fe0f38a4b51c0418a8b54de80.svg";
export { ForwardRef as ReactComponent };